import React, { useState } from "react";
import { CloseIcon } from "../../assets";

import "./Modal.scss";

export type ModalProps = {
  cx?: string;
  title?: string | { icon: SVGElement; text?: string };
  list?: { title: string; component: JSX.Element }[];
  close: any;
};

export const Modal: React.FC<ModalProps> = ({
  cx = "",
  children,
  title,
  list,
  close,
}) => {
  const [select, setSelect] = useState<{
    title: string;
    component: JSX.Element;
  }>(
    !!list
      ? list[0]
      : {
          title: "",
          component: <></>,
        }
  );
  return (
    <div className={"Modal-wrapper"}>
      <div className={`Modal ${cx}`}>
        <div className="header">
          {!!title && <span className={"title-only"}>{title}</span>}
          {!!list && (
            <ul className={"tab-wrapper"}>
              {list.map((i, idx) => (
                <li
                  key={"tab" + idx}
                  onClick={() => setSelect(i)}
                  className={`tab ${select.title === i.title ? "active" : ""}`}
                >
                  {i.title}
                </li>
              ))}
            </ul>
          )}
          <CloseIcon onClick={close} />
        </div>
        {!!title && <div className={"contents"}>{children}</div>}
        {!!list && select.component}
      </div>
    </div>
  );
};
